import {Person, Project, StyledBaseProps} from "@betrue/shared/interfaces";
import styled from "styled-components";
import {Button, Grid, TextField} from "@material-ui/core";
import {ProjectFormProps} from "@betrue/ui";
import * as React from "react";
import {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {ProjectFormForm, projectFormValidationSchema} from "./project-form.form";
import moment from "moment";

interface ProjectFormViewProps extends StyledBaseProps, ProjectFormProps {
  currentUser: Person,
  project: Project
  onCreateProject: (form: ProjectFormForm) => void
}

export const ProjectFormView = styled((props: ProjectFormViewProps) => {
  const {register, handleSubmit, control, formState: {errors}, reset} = useForm<ProjectFormForm>({
    defaultValues: props.project,
    resolver: yupResolver(projectFormValidationSchema)
  })

  useEffect(() => {
    reset(props.project);
  }, [props.project])

  return (
    <div className={props.className}>
      <form onSubmit={handleSubmit(props.onCreateProject)}>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={4}>
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction="column"
              spacing={7}
            >
              <Grid item xs={12}>
                <Controller
                  defaultValue={props.project.name}
                  name={"name"}

                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={`${props.projectNameLabel} *`}
                      variant="outlined"
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>
                  )
                  }
                  control={control}/>
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name={"dueDate"}

                  render={({field, fieldState, formState}) => (
                    <TextField
                      label={props.dueDateLabel}
                      variant="outlined"
                      required={false}
                      value={moment(field.value).format('YYYY-MM-DD')}

                      type={"date"}
                      onChange={(date) => {
                        field.onChange(date)
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>

            </Grid>

          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction="column"
              spacing={4}
            >
              <Grid item xs={12}>
                <Controller
                  defaultValue={props.project.description}
                  name={"description"}
                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.projectDescriptionLabel}
                      multiline
                      variant="outlined"
                      rows={7}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>
            </Grid>

          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              alignItems={"flex-end"}
              spacing={4}
            >
              <Grid item xs={12}>
                <Button type={"submit"} variant="outlined" color="primary">
                  {props.projectSubmitLabel}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  )
})`

  & .bt-warning {
    color: ${props => props.theme.colors.warning}
  }

  & .bt-done {
    color: ${props => props.theme.colors.success}
  }

  & .bt-success {

  }

  & .bt-completion-circle {

    margin: 10px;
  }
`
